module.exports = __webpack_public_path__ + "img/five.4a51d1b7.gif";